"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkIsPhoneNumber = function (value) { return (!/[^1-9/+]/gi.test(value)); };
exports.default = checkIsPhoneNumber;
